import { ONGLET_EMPLOYEUR, ONGLET_FORMATION } from "../shared"

export const OngletsPROA = [ONGLET_EMPLOYEUR, 'Salarie', 'Contrat', ONGLET_FORMATION] as const
export type OngletPROA = typeof OngletsPROA[number]

export const OngletsPROALibellés: Record<OngletPROA, string> = {
  Employeur: 'Employeur',
  Salarie: 'Salarié',
  Contrat: 'Contrat',
  Formation: 'Formation'
}
